import React, { useMemo, useState } from "react";
import SlidePanel from "./SlidePanel";

export default function FavoritesPanel({ ships, favorites, pendingIds, onShipClick, onToggle, onClose }) {
  const [query, setQuery] = useState("");

  // keep the order the user favorited them in (newest first)
  const favShips = useMemo(() => {
    const byId = new Map(ships.map((s) => [Number(s.id), s]));
    return [...favorites].reverse().map((id) => byId.get(id)).filter(Boolean);
  }, [ships, favorites]);

  const shown = favShips.filter((s) => s.title.toLowerCase().includes(query.toLowerCase()));

  return (
    <SlidePanel title="Favorite Ships" subtitle={`${favShips.length} saved`} onClose={onClose}>
      {favShips.length > 4 && (
        <input
          className="panel-search"
          type="text"
          placeholder="Filter favorites…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      )}

      {favShips.length === 0 ? (
        <div className="panel-empty">
          <div className="panel-empty-icon">☆</div>
          <p>No favorites yet.</p>
          <p className="panel-muted">Open a ship on the map and press <strong>☆ Favorite</strong> to save it here.</p>
        </div>
      ) : shown.length === 0 ? (
        <p className="panel-muted">No favorites match “{query}”.</p>
      ) : (
        <div className="panel-list">
          {shown.map((ship) => (
            <div key={ship.id} className="panel-item">
              <div className="panel-thumb">
                {ship.images?.[0] ? <img src={ship.images[0]} alt="" loading="lazy" onError={(e) => (e.currentTarget.style.display = "none")} /> : <span>⚓</span>}
              </div>
              <div className="panel-item-main">
                <h3>{ship.title}</h3>
                <div className="panel-meta">
                  {ship.type && ship.type !== "unknown" && <span>{ship.type}</span>}
                  {ship.date && ship.date !== "unknown" && <span>{ship.date}</span>}
                </div>
                <div className="panel-row-actions">
                  <button className="panel-link" onClick={() => onShipClick(ship)}>Show on map →</button>
                  <button
                    className="panel-link danger"
                    disabled={pendingIds.includes(Number(ship.id))}
                    onClick={() => onToggle(ship.id)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </SlidePanel>
  );
}
